<script lang="ts">
import { defineComponent, SetupContext, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { comparisonsApi } from '@/services/comparisons.service'
import { useToast } from 'vue-toast-notification'
import { useComparisonsStore } from './store'

export default defineComponent({
  props: {
    state: {
      type: Boolean,
      default: false,
    },
    id: Number,
  },
  emits: ['finish-comparisons'],
  setup(props: { state: boolean; id: number }, { slots, emit }: SetupContext) {
    const $toast = useToast()

    const { getCount } = useComparisonsStore()

    const state = ref<boolean>(props.state)
    const loading = ref<boolean>(false)

    const { t } = useI18n()

    async function toggle() {
      if (loading.value) return

      loading.value = true
      if (state.value) {
        state.value = false
        await comparisonsApi.remove
          .execute({}, { offerIds: [props.id] })
          .then(() => {
            emit('finish-comparisons', state.value)
            $toast.info(t('Offer removed from comparisons!'))
          })
          .catch(() => {
            $toast.error(t('Something went wrong! Try later!'))
            state.value = true
          })
          .finally(() => {
            loading.value = false
          })
      } else {
        state.value = true
        await comparisonsApi.add
          .execute({}, { offerIds: [props.id] })
          .then(({ data: { item, items } }) => {
            const [categoryObj] = item || items
            const category = {
              id: categoryObj.categoryId,
              slug: categoryObj.slug,
            }
            const comparisonUrl = window.comparison_url
            const query = new URLSearchParams()
            query.set('category', btoa(JSON.stringify(category)))
            const url = `${comparisonUrl}?${query.toString()}`
            emit('finish-comparisons', state.value)
            $toast.info(
              `<span>${t(
                'Offer added to'
              )} </span> <a class="ds-link ds-link--styling_underlined" href="${url}">${t(
                'comparisons'
              )}</a>!`
            )
          })
          .catch(() => {
            state.value = false
            $toast.error(t('Something went wrong! Try later!'))
          })
          .finally(() => {
            loading.value = false
          })
      }
      getCount()
    }

    return () =>
      slots.default?.({
        state: state.value,
        toggle,
      })
  },
})
</script>
